import { Box, Typography } from '@mui/material';
import { IInnerStateCheque } from '../../pages/requestSteps/cheques/IInnerstate';
import ElementTitle from '../title/elementTitle/elementTitle';
import CustomisedCardDivider from '../card/cardDivider';
import { NumberDisplay } from '../numberDisplay/numberDisplay';
import { IChequeGuide } from './IChequeGuide';


export default function ChequeGuide({ dueDatePersian,
    dueDateAlphabet,
    amount,
    amountAlphabet,
    expectedHolder,
    expectedIdCode,
    reasonTitle }
    : IChequeGuide) {
    return (
        <div >
            <div style={{ marginBottom: '20px !important' }}>
                <Typography
                    sx={{ fontSize: '13px' }}
                    className="primaryColorLight-900 !mt-3"
                >
                    با توجه به راهنمای زیر، چک خود را بنویسید. سپس شماره
                    صیادی آن را در بخش مشخص شده زیر جهت استعلام وارد نمایید.
                </Typography>
                <Box
                    sx={{
                        background: 'var(--header-color)',
                        border: 'dashed 2px var(--border-color)',
                        padding: '15px',
                        borderRadius: '4px',
                        marginTop: '.6rem',
                    }}
                >
                    <ElementTitle title="تاریخ" />
                    <div className="mt-2">
                        <CustomisedCardDivider
                            part1={
                                <NumberDisplay
                                    number={
                                        dueDatePersian!.split('/').join('')}
                                />
                            }
                            part2={dueDateAlphabet}
                        />
                    </div>

                    <div className="mt-6">
                        <ElementTitle title=" مبلغ چک (ریال)" />
                    </div>
                    <div className="mt-3">
                        <CustomisedCardDivider
                            part1={amount!.toLocaleString()}
                            part2={amountAlphabet}
                        />
                    </div>
                    <div className="mt-6">
                        <ElementTitle title="در وجه" />
                    </div>
                    <div className="mt-3">
                        <CustomisedCardDivider
                            part1={expectedHolder!}
                            part2={`شناسه ملی ${expectedIdCode}`}
                        />
                    </div>
                    <div className="mt-6">
                        <ElementTitle title="دلیل صدور چک" />
                    </div>
                    <div className="mt-3">
                        <CustomisedCardDivider
                            part1={reasonTitle!}
                        />
                    </div>
                </Box>
            </div>
        </div>
    );
}
